import angular from "angular";
import { AccountUserModule } from "../../account/user/account-user.module";
import { WagePolicyModule } from "../../wage-policy/wage-policy.module";
import { EditEmployeeBankInfoContainerComponent } from "./edit-employee-bank-info-container.component";
import { EditEmployeeContainerComponent } from "./edit-employee-container.component";
import { EditEmployeeComponent } from "./edit-employee.component";
import { EditUserProfileComponent } from "./edit-user-profile.component";
import { EmployeeAccountEditorComponent } from "./employee-account-editor.component";
import { EmploymentRecordEditorModule } from "./employment-record-editor/employment-record-editor.module";
import { UserSecurityEditorModule } from "./security-editor/user-security-editor.module";
import { EditEmployeeOnboardingProfileComponent } from "./edit-employee-onboarding-profile.component";

export const RosterEditModule = angular
    .module("apex.mainApp.roster.edit", [
        AccountUserModule,
        WagePolicyModule,
        EmploymentRecordEditorModule,
        UserSecurityEditorModule
    ])
    .component("apexEditEmployeeBankInfoContainer", EditEmployeeBankInfoContainerComponent)
    .component("apexEditEmployee", EditEmployeeComponent)
    .component("apexEditUserProfile", EditUserProfileComponent)
    .component("apexEditEmployeeContainer", EditEmployeeContainerComponent)
    .component("apexEmployeeAccountEditor", EmployeeAccountEditorComponent)
    .component("apexEmployeeOnboardingProfile", EditEmployeeOnboardingProfileComponent)
    .name;
